import type { ReactNode } from 'react';
import type { UiShellVersion } from '../app/runtime-config';
import { PageFrame } from './PageFrame';

export interface AppShellProps {
  version: UiShellVersion;
  collapsed?: boolean;
  sidebar: ReactNode;
  header: ReactNode;
  toasts?: ReactNode;
  phone?: ReactNode;
  children: ReactNode;
}

export function AppShell({ version, collapsed = false, sidebar, header, toasts, phone, children }: AppShellProps) {
  if (version === 'legacy') {
    return (
      <div className={`app-shell${collapsed ? ' sidebar-collapsed' : ''}`} data-ui-shell-version="legacy">
        {sidebar}
        <div className="workspace">
          {header}
          {toasts}
          {phone}
          <main className="page-area">{children}</main>
        </div>
      </div>
    );
  }

  return (
    <div className="app-shell ihd-app-shell" data-ui-shell-version="v2">
      {sidebar}
      <div className="workspace ihd-workspace">
        {header}
        {toasts && <div className="ihd-shell-toasts">{toasts}</div>}
        {phone && <div className="ihd-shell-phone">{phone}</div>}
        <PageFrame>{children}</PageFrame>
      </div>
    </div>
  );
}
